import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";

const Header = () => {
  const { t, i18n } = useTranslation();
  const { isAuthenticated } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = window.location.pathname;
  const isArabic = i18n.language === "ar";

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Navigation items configuration - will be reversed for Arabic
  const navItemsConfig = [
    { key: "home", path: "/", translationKey: "header.home" },
    { key: "about", path: "/about", translationKey: "header.about" },
    { key: "contact", path: "/contact", translationKey: "header.contact" },
  ];

  // Reverse order for Arabic
  const displayNavItems = isArabic ? [...navItemsConfig].reverse() : navItemsConfig;

  return (
    <>
      {/* Inline styles to override any CSS conflicts */}

      <header className="header-fix" dir="ltr">
        {/* Logo - Left side */}
        {/* Logo removed as per user request */}

        {/* Navigation Buttons - Centered on desktop, slide menu on mobile */}
        <nav className={`contact-fix ${isMenuOpen ? 'menu-open' : ''}`}>
          {displayNavItems.map((item) => (
            <button
              key={item.key}
              className={`contact-item-fix${pathname === item.path ? " nav-selected" : ""
                }`}
              onClick={() => { navigate(item.path); closeMenu(); }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
              }}
            >
              {t(item.translationKey)}
            </button>
          ))}
        </nav>

        {/* Desktop Controls - Right side on desktop */}
        <div className="controls-fix">
          <div
            className="language-fix"
            onClick={toggleLanguage}
            style={{ cursor: "pointer" }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#303E4E"
                strokeWidth="1.5"
              />
              <path
                d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                stroke="#303E4E"
                strokeWidth="1.5"
              />
            </svg>
            <span>{i18n.language === "en" ? "EN" : "AR"}</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M7 10l5 5 5-5" stroke="#303E4E" strokeWidth="1.5" />
            </svg>
          </div>
          <button
            className="login-fix"
            onClick={() => {
              if (isAuthenticated) {
                // If already on /social, scroll to top instead of navigating
                if (location.pathname === "/social") {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                } else {
                  navigate("/social");
                }
              } else {
                navigate("/auth/login");
              }
            }}
          >
            {isAuthenticated ? t("header.connect") : t("login.loginButton")}
          </button>
        </div>

        {/* Mobile Controls and Hamburger */}
        <div className="controls-fix-mobile">
          <div
            className="language-fix"
            onClick={toggleLanguage}
            style={{ cursor: "pointer" }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#303E4E"
                strokeWidth="1.5"
              />
              <path
                d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                stroke="#303E4E"
                strokeWidth="1.5"
              />
            </svg>
            <span>{i18n.language === "en" ? "EN" : "AR"}</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M7 10l5 5 5-5" stroke="#303E4E" strokeWidth="1.5" />
            </svg>
          </div>
          <button
            className="login-fix"
            onClick={() => {
              if (isAuthenticated) {
                const userType = userDataService.getUserType();
                const isAdmin = userType === "ADMIN" || userType === "CONTENT_ADMIN";
                
                if (isAdmin) {
                  navigate(userDataService.getDefaultRedirect());
                } else if (location.pathname === "/social") {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                } else {
                  navigate("/social");
                }
              } else {
                navigate("/auth/login");
              }
            }}
          >
            {isAuthenticated ? t("header.connect") : t("login.loginButton")}
          </button>
        </div>

        {/* Hamburger Menu Button - Mobile Only */}
        <button
          className="hamburger-menu-btn"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            {isMenuOpen ? (
              <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            ) : (
              <>
                <path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </>
            )}
          </svg>
        </button>
      </header>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isMenuOpen ? 'menu-open' : ''}`} onClick={closeMenu}></div>
    </>
  );
};

export default Header;
